import axios from "axios";
import { ActionIcon } from "rizzui/action-icon";
import { Text } from "rizzui/typography";
import { baseUrl } from "../account/login";
import { useContext, useState } from "react";
import { AuthContext } from "../../context/authContext";

export default function TestConnectionComponent({
  type,
  onSubmit,
}: {
  type: string;
  onSubmit: React.Dispatch<React.SetStateAction<string>>;
}) {
  const endpoint = {
    HubSpot: "integrations/hubspot/test_integration",
  };
  const { token } = useContext(AuthContext);
  const [isLoading, setIsLoading] = useState(false);
  const testConnection = () => {
    setIsLoading(true);
    axios
      .post(
        `${baseUrl}/${endpoint[type]}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        if (response?.data?.success) onSubmit("success");
        else onSubmit("failed");
      })
      .catch((e) => {
        onSubmit("failed");
      })
      .finally(() => setIsLoading(false));
  };

  return (
    <div className="border-[0.5px] border-muted p-[32px] rounded-[8px] w-full h-[203px]">
      <div className="flex flex-col gap-[32px]">
        <div className="flex flex-col gap-[8px] text-center">
          <Text className="font-ibmPlexSerif font-[600] text-[18px] text-primary-dark">
            Test connection
          </Text>
          <Text className="text-[#758599] font-switzer text-[14px] font-[400] w-[223px] mx-auto">
            Proceed to test your {type} connection
          </Text>
        </div>

        <ActionIcon
          className="w-fit !bg-transparent mx-auto text-primary-dark"
          onClick={testConnection}
          isLoading={isLoading}
          type="button"
        >
          <Text className="underline font-switzer text-[14px] text-primary-dark font-[500]">
            Test Connection here
          </Text>
        </ActionIcon>
      </div>
    </div>
  );
}
